import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tooltip from '../tooltip/tooltip';
import useDialog from '../dialog/useDialog';
import Dialog from '../dialog/dialog';
import PanelCard from '../panel-card/panel-card';
import CommentSection from './comment-section';

function CommentSectionTable({
  data,
  Icon,
  isEditor,
  handleCommentSubmit,
  removeBG,
  mode,
}) {
  const { isShowing: isActivateCommentDialog, toggle: toggleCommentDialog } =
    useDialog();
  const rejectQuote = data?.length === 2 && data[1]?.status !== 'Accepted';
  const buttonDisable = data?.[1]?.comment
    ? data?.[0]?.comment === '' && data?.[1]?.comment === ''
    : data?.[0]?.comment === '';
  const [t] = useTranslation('managebooking');
  return (
    <>
      {buttonDisable ? (
        <Tooltip
          content={t(
            'managebookingscreen.bookingdetails.comment.nocommenttooltip'
          )}
        >
          <button
            type="button"
            className={`icon-button ${removeBG ? 'no-bg' : ''} ${mode}`}
            id="note"
            onClick={toggleCommentDialog}
            disabled={buttonDisable}
          >
            <Icon />
          </button>
        </Tooltip>
      ) : (
        <button
          type="button"
          className={`icon-button ${removeBG ? 'no-bg' : ''} ${mode}`}
          id="note"
          onClick={toggleCommentDialog}
        >
          <Icon />
        </button>
      )}
      <Dialog
        isShowing={isActivateCommentDialog}
        hide={toggleCommentDialog}
        placement="center"
        maskZindex={1041}
      >
        <PanelCard
          cardTitle={t('managebookingscreen.bookingdetails.comment.note')}
          className="comment-width"
        >
          {rejectQuote && data?.[0]?.comment !== '' && (
            <span className="quotenotes">
              {t('managebookingscreen.bookingdetails.comment.quotenote')}
            </span>
          )}
          {data?.[0]?.comment !== '' && (
            <CommentSection
              commentData={data?.[0]}
              isEditor={isEditor}
              toggleCommentDialog={toggleCommentDialog}
              handleCommentSubmit={handleCommentSubmit}
            />
          )}
          {rejectQuote && data?.[1]?.comment !== '' && (
            <>
              <span className="reject-quote">
                {t('managebookingscreen.bookingdetails.comment.rejectionnote')}
              </span>
              <CommentSection commentData={data?.[1]} />
            </>
          )}
        </PanelCard>
      </Dialog>
    </>
  );
}

CommentSectionTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  Icon: PropTypes.element,
  isEditor: PropTypes.bool,
  handleCommentSubmit: PropTypes.func,
  removeBG: PropTypes.bool,
  mode: PropTypes.string,
};

CommentSectionTable.defaultProps = {
  data: [],
  Icon: () => null,
  isEditor: false,
  handleCommentSubmit: () => {},
  removeBG: false,
  mode: '',
};

export default CommentSectionTable;
